/* eslint-disable */

import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from '../Components/Footer'
import BottomNavbar from '../Components/BottomNavbar'
import Header from '../Components/Header'
import Navbar from '../Components/Navbar'
import { getUserDetails } from '../utils/AuthUtil'
import { useRecoilState } from 'recoil'
import { userDetailsState } from './LoginState'

const PostLoginContainer = () => {
  const location = useLocation()
  const isMFPage = location.pathname.includes('mutual-funds')

  const [lastRefresh, setLastRefresh] = useState('')
  const [refreshCount, setRefreshCount] = useState(0)

  const handleCustomRefresh = async () => {
    // Simulate API call or data refresh
    await new Promise((resolve) => setTimeout(resolve, 1500))

    setLastRefresh(new Date().toLocaleTimeString())
    setRefreshCount((prev) => prev + 1)
  }

  const hideBottonNav =
    location.pathname.includes('tax-filing') ||
    location.pathname.includes('firstTime') ||
    location.pathname.includes('place-order') ||
    location.pathname.includes('order-payment') ||
    location.pathname.includes('payment-request') ||
    location.pathname.includes('one-time-payment') ||
    location.pathname.includes('mutual-funds/mandate') ||
    location.pathname.includes('/dashboard/holdings')

  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)

  const hideTopNav =
    location.pathname.includes('mutual-funds') ||
    location.pathname.includes('tax-filing') ||
    location.pathname.includes('one-time-payment/status')

  const hideNavbar = location.pathname.includes('one-time-payment/status')

  useEffect(() => {
    setUserDetails(getUserDetails())
  }, [])

  return (
    <>
      {hideTopNav ? null : <Header />}

      {!hideNavbar && <Navbar />}

      <div className='flex justify-center'>
        <div
          className={`w-full ${
            !location.pathname.includes('/tax-filing') &&
            !location.pathname.includes('one-time-payment/status') &&
            'lg:mt-[52px]'
          } ${
            isMFPage ||
            location.pathname.includes('/tax-filing') ||
            location.pathname.includes('firstTime') ||
            location.pathname.includes('one-time-payment/status')
              ? 'max-w-auto mb-0'
              : 'max-w-[1128px] mb-16 lg:pb-12 lg:pt-4'
          }`}
        >
          <Outlet />
          {hideBottonNav ? null : <BottomNavbar />}
          <Footer />
        </div>
      </div>
    </>
  )
}

export default PostLoginContainer
